let org = {
    note: "注：通过右键菜单对组织机构进行操作",
    organization: "组织机构",
    orgDetail: "查看机构信息",
    updateOrg: "编辑机构",
    addOrg: "添加子机构",
    deleteOrg: "删除机构",
    orgNumber: "机构编号",
    orgName: "机构名称",
    enterOrgName: "请输入机构名称",
    orgParent: "父机构",
    orgParentName: "父机构名称",
    confirmDeleteOrg: "确认要删除机构{name}吗？（删除机构将会同时删除该机构下的所有子机构,可能会导致部分管理员没有组织机构无法登录）",
    selOrganization: "请选择组织机构",
}

export default org
